<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    isPrimaryButtonHidden="true" (closeButtonActionEmt)="closeModal()" secondaryButtonLabel="Close"
    [modalHelpIndex]="modalHelpIndex" [resizeHorizontal]="true" [resizeHorizontalMin]="560" [resizeVertical]="true"
    [resizeVerticalMin]="500">
    <div class="grid-container">
        <res-generic-grid gridName="Found Passwords" [automationId]="modalAutomationId" [(isBusy)]="isBusy"
            [(isBusyMessage)]="isBusyMessage" [gridContext]="gridContext" isRefreshIconHidden="true"
            [pagerTemplate]="hasDownloadPermission ? pagerTemplate : null" [columnDefs]="columnDefs"
            [requestInfo]="requestInfo" [headerTemplate]="headerTemplate">
        </res-generic-grid>
    </div>
    <ng-template #headerTemplate>
        <span>Found Passwords</span>
    </ng-template>
    <ng-template #pagerTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-download-button'"
            class="secondary-button icon-button" (click)="downloadFoundPasswords()" title="Download Filtered List ...">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>
    <a download #downloadFoundPasswordsLink hidden target="_blank"></a>
</res-base-modal>